<div class="payment-form-card-selector">
  <!-- Сохранённые способы оплаты -->
  <ng-template [ngIf]="paymentMethods?.length">
      <div class="cards-list">
        <ng-container *ngFor="let account of paymentMethods; trackBy: trackByFn">
          <app-payment-card
            [selected]="selected?.paymentMethod?.id === account.id"
            [is_test]="isTestCard(account)"
            (onSelect)="onSelect(account, 'account')"
            [account]="account" [view]="'simple'"
          ></app-payment-card>
        </ng-container>
      </div>
  </ng-template>
</div>

